import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-custom-2",
  "use": "icon-ie-custom-2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-custom-2\">\n    <path d=\"M51.616 602.496a128 128 0 0 1 0-180.992L413.632 59.456a128 128 0 0 1 181.024 0l362.048 362.048a128 128 0 0 1 0 180.992L594.656 964.544a128 128 0 0 1-181.024 0L51.616 602.496z\" fill=\"#1890FF\" p-id=\"2222\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol